export const useStyles = theme => ({
    fieldsContainer: {
        marginBottom: '60px',
    },
    field: {
        width: '95%',
    },
    requiredAsterisk: {
        color: '#009f3c',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    nextButton: {
        boxShadow: 'none !important',
    },
});